<template>
    <div>
        <footer id="footer">
            <section id="cooperation" class="d-flex align-items-center">
                <div class="container">
                     <div class="row pl-3 pr-3 pt-3">
                    <div class="col-lg-4 col-md-12 col-12 text-line-height-1 pb-3">
                        <p class="font-weight-900 title-main">联系我们</p>
                        <p class="title-sub">湖北省武汉市江夏区华工园三路1号湖北青创园4号楼5楼</p>
                        <p class="title-sub">联系电话: <a href="tel:15391566107" class="title-sub">15391566107(谢)</a></p>
                        <p class="title-sub">E-mail：<a href="mailto:xiebo@huoshen.info" target="_blank" class="title-sub">xiebo@huoshen.info</a></p>
                    </div>
                    <div class="col-lg-8 col-md-12 col-12">
                        <a href="https://ditu.amap.com/place/B0HKZDRZET" target="_blank">
                            <img src="@/assets/img/common/footer/map.png"  class="image-width-100"/>
                        </a>
                    </div>
                </div>
                <div class="row pt-5 text-align-center text-line-height-2 color-fff">
                    <h1 class="font-weight-bold title-sub">
                        程序保障<i class="norton-icon"></i>
                    </h1>
                    <span>公司的提供给客户的程序 是在norton保护下的软件开发,所有输出的程序是经过严格 Norton 消杀的</span><br />
                    <span>备案号：鄂ICP备2023002722号 <br />copyright © 火神信息2017-2022 All rights reserved.</span>
                </div>
                </div>
               
                 
            </section>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    components: {},
    props: {},
    data() {
        return {
        };
    },
    computed: {},
    watch: {},
    methods: {
    },
    created() {

    },
    mounted() {
    },
}
</script>
<style scoped></style>